import { motion } from "framer-motion";
import { X, Check } from "lucide-react";
import { steddyTransition } from "@/lib/animations";

const fadeInUp = {
  initial: { opacity: 0, y: 12 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
};

const rows = [
  { task: "Deal Underwriting", manual: "2–4 hours", steddy: "< 90 seconds" },
  { task: "Contract Generation", manual: "Manual drafting", steddy: "Auto-generated" },
  { task: "Final Underwriting", manual: "4–8 hours", steddy: "< 30 minutes" },
  { task: "Login Calls", manual: "Manual chase", steddy: "Online checkout" },
  { task: "Renewal Offers", manual: "Spreadsheet tracking", steddy: "AI-triggered" },
  { task: "Default Management", manual: "Reactive", steddy: "Predictive alerts" },
];

const ComparisonSection = () => (
  <section id="solutions" className="bg-background py-32">
    <div className="container mx-auto px-6">
      <motion.div {...fadeInUp} transition={steddyTransition} className="mb-16 text-center">
        <span className="text-xs font-semibold uppercase tracking-wider text-primary">
          Our Solutions
        </span>
        <h2 className="mt-4 text-3xl font-bold text-foreground md:text-4xl">
          Is your current system
          <br />
          stuck in 1995?
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-muted-foreground">
          We help funders move faster by eliminating paperwork, avoiding delays, and replacing
          outdated systems with AI-powered operations.
        </p>
      </motion.div>

      <motion.div
        {...fadeInUp}
        transition={{ ...steddyTransition, delay: 0.1 }}
        className="card-surface-light mx-auto max-w-3xl overflow-hidden rounded-2xl"
      >
        <div className="grid grid-cols-3 gap-4 border-b border-border px-6 py-4">
          <span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
            Task
          </span>
          <span className="text-center text-xs font-semibold uppercase tracking-wider text-muted-foreground">
            Without Steddy
          </span>
          <span className="text-center text-xs font-semibold uppercase tracking-wider text-primary">
            With Steddy.AI
          </span>
        </div>

        {rows.map((row, i) => (
          <div
            key={row.task}
            className="steddy-transition grid grid-cols-3 items-center gap-4 px-6 py-4 hover:bg-secondary/50"
            style={{ borderBottom: i < rows.length - 1 ? "1px solid hsl(240 10% 90%)" : "none" }}
          >
            <span className="text-sm font-medium text-foreground">{row.task}</span>
            <span className="flex items-center justify-center gap-2 text-center text-sm text-muted-foreground">
              <X className="h-3.5 w-3.5 text-destructive/70" />
              {row.manual}
            </span>
            <span className="flex items-center justify-center gap-2 text-center text-sm font-medium text-primary">
              <Check className="h-3.5 w-3.5" />
              {row.steddy}
            </span>
          </div>
        ))}
      </motion.div>
    </div>
  </section>
);

export default ComparisonSection;
